<div class="collapse-container">
  <div class="collapse-header mb-2" (click)="collapsed = !collapsed">
    <span>&#9660;</span>
    <span style="margin-left: 8px;">Description</span>
  </div>
  @if (!collapsed) {
    <div class="collapse-content">
      @if (entity?.layerPath !== 'ArcAngel//Updates') {
        <div>
          <div [innerHTML]="getSanitizedHtml()"></div>
        </div>
      }
      @if (entity?.layerPath === 'ArcAngel//Updates') {
        <div>
          <table class="table custom-table" style="width: 100%; background-color: #5d99fb;">
            <tr>
              <td>Sender:</td>
              <td>
                {{ name || 'Unknown' }}
                @if (userId) {
                  <i
                    class="fa fa-info-circle bg-transparent text-white"
                    (click)="viewUserInfo(this.entity.data.userInfo)"
                    style="cursor: pointer; margin-left: 20px"
                  title="user info"></i>
                }
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top">Message:</td>
              <td>{{ entity?.description }}</td>
            </tr>
          </table>
        </div>
      }
    </div>
  }
</div>